export function formatLocalDateTime(value: string | null | undefined): string {
  if (!value) return "Never"
  const date = parseUtcTimestamp(value)
  return date ? date.toLocaleString() : value
}

export function formatLocalDate(value: string | null | undefined): string {
  if (!value) return "Never"
  const date = parseUtcTimestamp(value)
  return date ? date.toLocaleDateString() : value
}

export function formatLocalShortDate(value: string | null | undefined): string {
  if (!value) return "Never"
  const date = parseUtcTimestamp(value)
  return date
    ? date.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })
    : value
}

export function parseUtcTimestamp(value: string): Date | null {
  const normalized = value.trim()
  if (!normalized) return null

  const timestamp = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}(?:\.\d+)?$/.test(normalized)
    ? `${normalized.replace(" ", "T")}Z`
    : normalized
  const date = new Date(timestamp)
  return Number.isNaN(date.getTime()) ? null : date
}
